import { IApiExceptionResponse } from './interfaces';

export class HttpError extends Error {
  public status: number;
  public apiException?: IApiExceptionResponse;

  constructor(status: number, message: string, apiException?: IApiExceptionResponse) {
    super(message);

    this.status = status;
    this.apiException = apiException;
  }
}

export function isHttpError(e: Error): e is HttpError {
  return (e as HttpError).status !== undefined;
}
